export const paymentAddressFields = ['address1', 'address2', 'city', 'province', 'zipCode'];
export const orderImgPattern = '_105x$1';
